<template>
  <div class="pc-banner">
    <div
      class="g-banner-div"
      v-if="
        extras.banner &&
        extras.banner.display == 1 &&
        extras.banner.colorOrBg == 'color'
      "
      :style="{
        backgroundColor:
          extras && extras.banner && extras.banner.color
            ? extras.banner.color
            : defaultColor,
      }"
    ></div>
    <a
      :href="extras.kvlink.model"
      v-if="
        extras.banner &&
        extras.banner.display == 1 &&
        extras.banner.colorOrBg == 'src' &&
        extras.kvlink &&
        extras.kvlink.display == 1
      "
    >
      <img
        class="g-banner-new"
        v-if="
          extras.banner &&
          extras.banner.display == 1 &&
          extras.banner.colorOrBg == 'src'
        "
        :src="
          extras.banner && extras.banner.src
            ? extras.banner.src
            : imgUrlObj.pc.kv
        "
      />
    </a>
    <img
      class="g-banner-new"
      v-if="
        extras.banner &&
        extras.banner.display == 1 &&
        extras.banner.colorOrBg == 'src' &&
        (extras.kvlink === undefined || extras.kvlink.display == 0)
      "
      :src="
        extras.banner && extras.banner.src ? extras.banner.src : imgUrlObj.pc.kv
      "
    />
    <div class="g-seminar-content-new">
      <div class="seminar-info">
        <div
          class="seminar-title"
          v-html="seminarInfo.title"
          :style="{
            display:
              extras.titlefont && extras.titlefont.display == 1
                ? 'block'
                : 'none',
            color: extras.titlefont && extras.titlefont.color,
          }"
        ></div>

        <div class="seminar-time" v-if="seminarInfo.startTime">
          <span
            :style="{
              display:
                extras.meetingTime && extras.meetingTime.display == 1
                  ? 'block'
                  : 'none',
              color: extras.meetingTime && extras.meetingTime.color,
            }"
            >{{
              handleTimeStamps(seminarInfo.startTime, seminarInfo.endTime)
            }}</span
          >
          <div
            :style="{
              display:
                extras.meetingAddress && extras.meetingAddress.display == 1
                  ? 'block'
                  : 'none',
              color: extras.meetingAddress && extras.meetingAddress.color,
            }"
            v-if="seminarInfo.address"
          >
            {{ seminarInfo.address }}
          </div>
        </div>
      </div>
      <div
        class="seminar-remainder"
        :style="{
          display:
            extras.meetingCountDown && extras.meetingCountDown.display == 1
              ? 'block'
              : 'none',
          color: extras.meetingCountDown && extras.meetingCountDown.color,
        }"
      >
        <span v-if="seminarStatus === 3">进行中</span>
        <span v-if="seminarStatus === 4">已结束</span>
        <span v-if="seminarStatus === 1"
          >距离会议开始<span
            class="seminar-remainder-num"
            :style="{
              color:
                extras.meetingCountDownNum && extras.meetingCountDownNum.color,
            }"
            >{{ remainder.days }}</span
          >天<span
            class="seminar-remainder-num"
            :style="{
              color:
                extras.meetingCountDownNum && extras.meetingCountDownNum.color,
            }"
            >{{ remainder.hours }}</span
          >时<span
            class="seminar-remainder-num"
            :style="{
              color:
                extras.meetingCountDownNum && extras.meetingCountDownNum.color,
            }"
            >{{ remainder.minutes }}</span
          >分</span
        >
      </div>
      <div class="seminar-btn" v-if="!isFrozen && seminarStatus !== 4">
        <div
          class="btn"
          :class="isSetting == 1 ? 'cursor-default' : ''"
          v-show="isSetting == 1 && extras.noSignUp.display == 1"
          :style="{
            backgroundColor: extras.signUpBg && extras.signUpBg.color,
          }"
        >
          {{ extras.noSignUp.model || "立即报名" }}
        </div>
        <div
          class="btn"
          v-show="
            isSetting !== 1 &&
            extras.noSignUp.display == 1 &&
            memberInfo.signUpStatus == 0 &&
            !isLogin &&
            seminarInfo.isOpenMember != 0 &&
            signUpUrl
          "
          :style="{
            backgroundColor: extras.signUpBg && extras.signUpBg.color,
          }"
          @click="goto('newLogin')"
        >
          {{ extras.noSignUp.model || "立即报名" }}
        </div>
        <div
          v-if="
            isSetting !== 1 &&
            extras.noSignUp.display == 1 &&
            memberInfo.signUpStatus == 0 &&
            (isLogin || seminarInfo.isOpenMember == 0) &&
            signUpUrl
          "
          class="btn"
          :style="{
            backgroundColor: extras.signUpBg && extras.signUpBg.color,
          }"
          @click="goto('signUp')"
        >
          {{ extras.noSignUp.model || "立即报名" }}
        </div>
        <div
          v-if="
            isSetting !== 1 &&
            extras.checkPending.display == 1 &&
            memberInfo.signUpStatus == 1
          "
          :style="{
            backgroundColor: extras.signUpBg && extras.signUpBg.color,
          }"
          class="btn audit"
          @click="goto('signUp')"
        >
          {{ extras.checkPending.model || "审核中..." }}
        </div>
        <div
          v-if="
            isSetting !== 1 &&
            extras.approve.display == 1 &&
            (memberInfo.signUpStatus == 2 || memberInfo.signUpStatus == 3)
          "
          :style="{
            backgroundColor: extras.signUpBg && extras.signUpBg.color,
          }"
          class="btn registered"
          @click="goto('signUp')"
        >
          {{ extras.approve.model || "报名成功" }}
        </div>
        <div
          v-if="
            isSetting !== 1 &&
            extras.reject.display == 1 &&
            memberInfo.signUpStatus == 4
          "
          :style="{
            backgroundColor: extras.signUpBg && extras.signUpBg.color,
          }"
          class="btn refuse"
          @click="goto('signUp')"
        >
          {{ extras.reject.model || "拒绝报名" }}
        </div>
        <div v-if="seminarStatus === 2" class="btn registered">会议已结束</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { handleTimeStampToDateTime } from "@/utils/utils";
import { URLS } from "fire-wind-water";
import Api from "../../service/api";
import { goto } from "../../mixins/goto";

export default {
  name: "Banner",
  props: {
    seminarInfo: Object,
    memberInfo: Object,
    signUpStatus: Number,
    loginUrl: String,
    registerUrl: String,
    isFrozen: Boolean,
    extras: {
      kv: {
        src: "",
      },
    },
  },
  data: function () {
    return {
      isLogin: false,
      signUpUrl: "",
      isSetting: 0,
      remainder: { days: 0, hours: 0, minutes: 0 },
      seminarStatus: 0, //0 未开始 1 已经开始 2 已经结束
      imgUrlObj: {
        pc: {
          kv: require("@/assets/images/pc/banner_new.png"),
        },
      },
      defaultColor: "#ffffff",
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  mounted() {
    const info = window.$sk.template.get();
    const smarketMember = info.cookie.getSession();
    this.isLogin = !!smarketMember;
    let signUpUrl = this.seminarInfo.signUp;
    const tc = URLS.getURL("tc");
    if (tc) {
      signUpUrl = `${signUpUrl}&tc=${tc}`;
    }
    this.signUpUrl = signUpUrl;
    if (this.seminarInfo && this.seminarInfo.startTime) {
      Api.getServerTime().subscribe((res) => {
        let startTime = this.seminarInfo.startTime * 1000;
        let endTime = this.seminarInfo.endTime * 1000;
        let currentTime = res.content * 1000;
        let diffTime = endTime;
        this.seminarStatus = 3;
        if (currentTime < startTime) {
          this.seminarStatus = 1;
          diffTime = startTime;
        } else if (currentTime > endTime) {
          this.seminarStatus = 4;
          return;
        }
        let dif = moment(diffTime).diff(res.content * 1000, "minutes");
        let days = Math.floor(dif / (24 * 60));
        let hours = Math.floor(dif / 60) - days * 24;
        let minutes = dif % 60;
        this.remainder = {
          days,
          hours,
          minutes,
        };
      });
    } else {
      this.seminarStatus = 0;
    }
  },
  methods: {
    goto(s) {
      let url = "";
      switch (s) {
        case "newLogin":
          url = goto.newLogin(
            URLS.updateSearchParam("openSign", "1", window.location.href),
            true
          );
          window.$sk.goto(url);
          break;
        case "login":
          goto.loginToSignUp();
          break;
        case "signUp":
          goto.signUp();
          break;
      }
    },
    handleTimeStamps: (startTimeStamp, endTimeStamp) => {
      let startTimeYear = handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY"
      );
      let endTimeYear = handleTimeStampToDateTime(endTimeStamp * 1000, "YYYY");
      let startDate = handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      let endDate = handleTimeStampToDateTime(
        endTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      if (startDate == endDate) {
        return (
          handleTimeStampToDateTime(
            startTimeStamp * 1000,
            "YYYY年MM月DD日 HH:mm"
          ) +
          "~" +
          handleTimeStampToDateTime(endTimeStamp * 1000, "HH:mm")
        );
      } else if (startTimeYear == endTimeYear) {
        return (
          handleTimeStampToDateTime(startTimeStamp * 1000, "YYYY年MM月DD日") +
          "~" +
          handleTimeStampToDateTime(endTimeStamp * 1000, "MM月DD日")
        );
      } else {
        return (
          handleTimeStampToDateTime(startTimeStamp * 1000, "YYYY年MM月DD日") +
          "~" +
          handleTimeStampToDateTime(endTimeStamp * 1000, "YYYY年MM月DD日")
        );
      }
    },
  },
};
</script>

<style scoped></style>
